export default [
  '/signin',
  '/tutor-registration',
  '/_error',
  '/request-subject',
  '/student/match-tutor',
  '/verify_phone',
  '/',
  '/intercom-booking',
  '/[cooperation]',
  '/[cooperation]/success',
  'student-enquiries',
  '/terms-and-conditions',
  '/search-referals',
  'hyperpay',
  'hyperpay_result',
  '/scheduler',
  '/speednet',
  '/about-us-new',
  '/become-a-tutor',
  '/intercom-scheduler',
  '/intercom-tutor-orders',
  '/intercom-tutor-calls',
  '/intercom-call-students',
  '/intercom-calendar-table',
  '/intercom-booking-flow',
  '/wallet',
  '/buy-hours',
  '/payment',
  '/payment/visa',
  '/payment/mada',
  '/payment/successful',
  '/payment/verification',
  '/apps',
  '/app',
  '/post-message',
  'request-university-tutor',
  '/upload-1607496161569',
  '/mobile-upload-attachment-for-broadcast',
  '/add-attachment-to-booking-room',
  '/submit-application',
  '/add-attachment-to-booking-room',
  '/mobile-booking-flow',
  '/sentry_sample_error',
  '/student/feedback-form',
  '/mobile-booking-details',
  '/expired-booking',
  '/student/leaderboard',
  '/student/points',
  '/student/prize-wheel',
  '/student/complaints-onboarding',
  '/student/join-session',
  '/tutor/grades-onboarding',
  '/howto',
  '/daleel',
  '/refund-policy',
  '/support',
  '/mobile-profile',
  '/change-phone-number',
  '/change-phone-number-unavailable',
  '/verify_new_phone',
  '/university-booking',
  '/makhfi-report',
  '/almkhfai-exams',
  '/connectivity-test',
  '/workshops/[id]',
  '/workshops/[id]/discussions',
  '/workshops/[id]/create-discussion',
  '/workshops/[id]/discussions/[discussionId]',
  '/mobile-report-booking',
  '/student/post-session-analysis/[sessionClassId]',
  '/session_details',
  '/mobile-booking-cancel',
  '/whiteboard/[roomName]',
  '/mobile-booking-cancel',
  '/makhfi-page',
  '/payments/verify',
  '/payments/successful',
  '/takaful-register',
  '/takaful-register/success',
  '/tutor-payment-report',
  '/tutor/tutor-payment-report',
  '/tutor/www.faheemapp.com/tutor-payment-report',
  '/transferred-tutor-booking',
  '/test-connectivity',
];
